import { LigneParametrage } from './ligne-parametrage.interface';
import { ColonneParametrage } from './colonne-parametrage.model';

export class Parametrage {
	colonnes: ColonneParametrage[];
	ligneParametrages: LigneParametrage[];

	deserialize(input): this {
		Object.assign(this, input);

		if (input.colonnes) {
			this.colonnes = [...input.colonnes.map(colonne => new ColonneParametrage(colonne.key, colonne.header).deserialize(colonne))];
		}

		if (input.ligneParametrages) {
			this.ligneParametrages = [...input.ligneParametrages.map(ligneParametrage => new LigneParametrage().deserialize(ligneParametrage))];
		}

		return this;
	}
}
